import { useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { useLanguage } from '../../../../contexts/LanguageContext';

const VehicleSearchForm = ({ formData, onFieldChange, onSubmit, loading }) => {
    const { th } = useLanguage();
    const toast = useRef(null);

    const handleSubmit = () => {
        if (!formData.chassisNo || formData.chassisNo.trim() === '') {
            toast.current?.show({
                severity: 'warn',
                summary: th('vehicleDetailInformation.searchForm.missingInfoSummary'),
                detail: th('vehicleDetailInformation.searchForm.missingInfoDetail'),
                life: 3000
            });
            return;
        }
        onSubmit();
    };

    return (
        <div className="flex flex-column gap-3 mb-4">
            <Toast ref={toast} />
            <div className="flex gap-3 align-items-end">
                <span className="p-float-label">
                    <InputText
                        id="chassisNo"
                        value={formData.chassisNo}
                        onChange={(e) => onFieldChange('chassisNo', e.target.value)}
                        className="w-20rem"
                        placeholder={th('vehicleDetailInformation.searchForm.chassisNoPlaceholder')}
                    />
                    <label htmlFor="chassisNo">{th('vehicleDetailInformation.searchForm.chassisNoLabel')}</label>
                </span>
                <Button 
                    label={th('vehicleDetailInformation.searchForm.searchButton')} 
                    onClick={handleSubmit} 
                    loading={loading} 
                />
            </div>
        </div>
    );
};

export default VehicleSearchForm;
